import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAppUrl } from "../config";
import { logos } from "../logos";
import {
	AUTH_TOKEN_CHANGE_EVENT,
	isAuthenticated,
} from "../utils/tokenStorage";

const NAV_ITEMS = [
	{ href: "#team", label: "Team" },
	{ href: "#about", label: "About" },
	{ href: "#company", label: "Company" },
] as const;

const Header = () => {
	const [loggedIn, setLoggedIn] = useState<boolean>(() => isAuthenticated());

	useEffect(() => {
		const syncAuthState = () => {
			setLoggedIn(isAuthenticated());
		};

		window.addEventListener("storage", syncAuthState);
		window.addEventListener("focus", syncAuthState);
		window.addEventListener(AUTH_TOKEN_CHANGE_EVENT, syncAuthState);

		return () => {
			window.removeEventListener("storage", syncAuthState);
			window.removeEventListener("focus", syncAuthState);
			window.removeEventListener(AUTH_TOKEN_CHANGE_EVENT, syncAuthState);
		};
	}, []);

	const accountAppUrl = getAppUrl("accountApp");
	const loginUrl = loggedIn ? accountAppUrl : `${accountAppUrl}/login`;

	return (
		<header className="h-16 bg-black/80 backdrop-blur-sm fixed top-0 left-0 right-0 z-50 border-b border-white/[0.06]">
			<div className="container mx-auto px-6 h-full">
				<div className="flex justify-between items-center h-full">
					<Link to="/" className="flex items-center space-x-3">
						<img
							className="h-8"
							src={logos.icon}
							alt="Blackadder Icon"
							width="auto"
						/>
						<img
							className="h-3.5"
							src={logos.fullWhite}
							alt="Blackadder"
							width="auto"
						/>
					</Link>

					{/* Desktop Navigation Links */}
					<nav className="hidden md:flex items-center space-x-1">
						{NAV_ITEMS.map((item) => (
							<a
								key={item.href}
								href={item.href}
								className="px-4 py-2 text-sm text-neutral-400 hover:text-white transition-colors duration-300"
							>
								{item.label}
							</a>
						))}
					</nav>

					{/* Login Button */}
					<a
						href={loginUrl}
						className="md:ml-4 px-5 py-2 text-sm bg-white text-black font-medium rounded-full hover:bg-neutral-200 transition-colors duration-300"
					>
						{loggedIn ? "My Account" : "Login"}
					</a>
				</div>
			</div>
		</header>
	);
};

export default Header;
